import BaseHelper from './BaseHelper'
import { colorScaleFromConfig } from '../../../utils/colorUtils'
import * as COLORS from '../utils/colorUtils'
import { extent as d3_extent } from 'd3-array'
import { scaleOrdinal as d3_scaleOrdinal, scaleSequential as d3_scaleSequential } from 'd3-scale'
import { interpolateRgbBasis as d3_interpolateRgbBasis } from 'd3-interpolate'
import {} from 'd3-transition'

export const DEFAULT_DURATION = 1000
export const DEFAULT_DELAY_STEP = 80

export default class ItemsHelper extends BaseHelper {
  static configName = 'ItemsHelper'

  static defaultConfig = {
    index: 101,
    className: {
      type: String,
      default: 'item',
    },
    /**
     * Colors to be assigned to each item. See [colorScales](#/developer/PropDetails#colorScale)
     */
    colorScale: {
      type: [String, Function, Array, Object],
      default: 'categorical',
      options: ['categorical', 'sequential2', 'sequential3', 'single'],
      exposed: true,
    },
    /**
     * Dictionary to "manually" assign a color to each item. See [colorScales](#/developer/PropDetails#colorScale)
     */
    colorDict: {
      type: [Object, Array, null],
      default: null,
      exposed: true,
    },
    colorMode: {
      type: [String, Array],
      default: 'fill',
      options: ['fill', 'stroke'],
    },
    colorKey: {
      type: [String, Function],
      default: 'id',
    },
    /**
     * Enable/disable transition between datasets. Set to `true` for a `400ms` transition. Or specify the `Number` of miliseconds.
     */
    transition: {
      type: [Boolean, Number, String],
      default: true,
      exposed: true,
    },
  }
  static init() {
    this.__itemsNames = []
  }
  static _getCategories = function (data) {
    return Object.keys(
      data.reduce((res, d) => {
        let id = this._colorKey(d)
        res[id] = {}
        return res
      }, {})
    ).map(str => {
      //PRESERVAMOS "ids que son Number"
      return isNaN(Number(str)) ? str : +str
    })
  }
  static _getScheme = function (schemeId, data) {
    if (schemeId === 'PRIMARY_CAT_SCHEME') {
      let categories = this._getCategories(data)
      if (categories.length < 9) schemeId = 'PRIMARY_CAT_SCHEME_LOW'
      else if (categories.length < 16) schemeId = 'PRIMARY_CAT_SCHEME_MID'
      else schemeId = 'PRIMARY_CAT_SCHEME_HIGH'
    }
    return COLORS[schemeId + (this.config.skin === 'dark' ? '_DARK' : '')]
  }
  static _setCachedColorScale = function (colorScale, colorDict, i) {
    let customColors =
      colorDict &&
      Object.keys(colorDict).reduce((res, key) => {
        res[key] = colorDict[key].color || colorDict[key]
        return res
      }, {})

    //Excepciones male/female.. :(
    let data
    if (!Array.isArray(this.data)) {
      if (i === 1) data = this.data.male
      else data = this.data.female
    } else data = this.data

    // Si hay custom colors pero no rellenan todo, rellenamos con los "que se pueda" de la primary_cat_scheme
    if (
      colorScale === 'categorical' &&
      customColors &&
      data.filter(d => !customColors[this._colorKey(d)]).length > 0
    ) {
      let unusedColors = [...this._getScheme('PRIMARY_CAT_SCHEME', data)]
      unusedColors = unusedColors.filter(d => Object.values(customColors).indexOf(d) < 0)
      data.forEach((d, i) => {
        if (!customColors[this._colorKey(d)]) {
          customColors[this._colorKey(d)] = unusedColors[0]
          unusedColors.shift()
        }
      })
    }

    let result
    if (colorScale === 'single') {
      result = () => (customColors ? customColors['all'] : this._getScheme('PRIMARY_COLOR'))
      result.isSinlge = true
    } else if (colorScale === 'single2') {
      result = () => (customColors ? customColors['all'] : this._getScheme('SECONDARY_COLOR'))
      result.isSinlge = true
    } else if (colorScale === 'categorical') {
      if (customColors)
        result = d3_scaleOrdinal()
          .domain(Object.keys(customColors))
          .range(Object.values(customColors))
      // else
      //   result = d3_scaleOrdinal(this._getScheme('PRIMARY_CAT_SCHEME', data)).domain(
      //     (this.cachedColorScale?.domain && this.cachedColorScale.domain()) ||
      //       this._getCategories(data)
      //   ) //en teoria asi cacheamos los colores DEVERDAD, sino volver al this._getCategories(data)
      else {
        //en teoria asi cacheamos los colores DEVERDAD, sino volver al newDomoain =  this._getCategories(data)
        let newDomain = this._getCategories(data)
        let oldDomain = this.cachedColorScale?.domain && this.cachedColorScale.domain()
        if (
          oldDomain &&
          newDomain.reduce((found, n) => found || oldDomain.find(o => o === n), null)
        ) {
          result = this.cachedColorScale.domain(oldDomain)
        } else {
          result = d3_scaleOrdinal(this._getScheme('PRIMARY_CAT_SCHEME', data)).domain(newDomain)
        }
      }
    } else if (colorScale === 'categorical2') {
      if (customColors)
        result = d3_scaleOrdinal()
          .domain(Object.keys(customColors))
          .range(Object.values(customColors))
      // else
      //   result = d3_scaleOrdinal(this._getScheme('PRIMARY_CAT_SCHEME', data).slice(1)).domain(
      //     (this.cachedColorScale?.domain && this.cachedColorScale.domain()) ||
      //       this._getCategories(data)
      //   ) //en teoria asi cacheamos los colores DEVERDAD, sino volver al this._getCategories(data)
      else {
        //en teoria asi cacheamos los colores DEVERDAD, sino volver al newDomoain =  this._getCategories(data)
        let newDomain = this._getCategories(data)
        let oldDomain = this.cachedColorScale?.domain && this.cachedColorScale.domain()
        if (
          oldDomain &&
          newDomain.reduce((found, n) => found || oldDomain.find(o => o === n), null)
        ) {
          result = this.cachedColorScale.domain(oldDomain)
        } else {
          result = d3_scaleOrdinal(this._getScheme('PRIMARY_CAT_SCHEME', data).slice(1)).domain(
            newDomain
          )
        }
      }
    } else if (colorScale === 'sequential2') {
      //Cuando salimos de "categorical" hay que resetear la cahchedColorScale!!!
      this.cachedColorScale = null
      if (customColors)
        result = d3_scaleSequential().interpolator(
          d3_interpolateRgbBasis(Object.values(customColors))
        )
      else
        result = d3_scaleSequential().interpolator(
          d3_interpolateRgbBasis(this._getScheme('PRIMARY_SEQ2_SCHEME'))
        )
    } else if (colorScale === 'sequential3') {
      //Cuando salimos de "categorical" hay que resetear la cahchedColorScale!!!
      this.cachedColorScale = null
      if (customColors)
        result = d3_scaleSequential().interpolator(
          d3_interpolateRgbBasis(Object.values(customColors))
        )
      else
        result = d3_scaleSequential().interpolator(
          d3_interpolateRgbBasis(this._getScheme('PRIMARY_SEQ3_SCHEME'))
        )
    } else if (typeof this.config.ItemsHelper.colorScale === 'object') {
      //Cuando salimos de "categorical" hay que resetear la cahchedColorScale!!!
      this.cachedColorScale = null
      // No esta claro si debe usar "this.data" o "this.__allTimeValues"
      // let values = this.data.map(d => d.value)
      let values = this.__allTimeValues
      let extent = d3_extent(values)
      result = colorScaleFromConfig(this.config.ItemsHelper.colorScale, values)
    } else {
      result = colorScale
    }
    return result
  }

  static update() {
    if (Array.isArray(this.config.ItemsHelper.colorScale)) {
      this.cachedColorScale = []
      this.config.ItemsHelper.colorScale.forEach((c, i) => {
        this.cachedColorScale[i] = this._setCachedColorScale(
          this.config.ItemsHelper.colorScale[i],
          this.config.ItemsHelper.colorDict[i],
          i
        )
      })
    } else {
      this.cachedColorScale = this._setCachedColorScale(
        this.config.ItemsHelper.colorScale,
        this.config.ItemsHelper.colorDict
      )
    }
  }

  static _colorKey = function (d) {
    if (typeof this.config.ItemsHelper.colorKey === 'function')
      return this.config.ItemsHelper.colorKey(d)
    else return d[this.config.ItemsHelper.colorKey]
  }

  static color = function (d, i) {
    if (typeof this.config.ItemsHelper.colorScale === 'function') {
      return this.cachedColorScale(d)
    } else {
      if (Array.isArray(this.cachedColorScale)) {
        return this.cachedColorScale[i](this._colorKey(d))
      } else {
        return this.cachedColorScale(this._colorKey(d))
      }
    }
  }

  static strokeDasharray = function (d, i) {
    let dict = Array.isArray(this.config.ItemsHelper.colorDict)
      ? this.config.ItemsHelper.colorDict[i]
      : this.config.ItemsHelper.colorDict
    let mode = Array.isArray(this.config.ItemsHelper.colorMode)
      ? this.config.ItemsHelper.colorMode[i]
      : this.config.ItemsHelper.colorMode
    if (mode === 'stroke' && dict) {
      if (dict[this._colorKey(d)] && dict[this._colorKey(d)].stroke === 'dashed') return '5 3'
      else return 'none'
    } else return 'none'
  }

  static thickness = function (d, i) {
    let dict = Array.isArray(this.config.ItemsHelper.colorDict)
      ? this.config.ItemsHelper.colorDict[i]
      : this.config.ItemsHelper.colorDict
    let mode = Array.isArray(this.config.ItemsHelper.colorMode)
      ? this.config.ItemsHelper.colorMode[i]
      : this.config.ItemsHelper.colorMode
    if (mode === 'stroke' && dict) {
      if (dict[this._colorKey(d)] && dict[this._colorKey(d)].thickness === 'thick') return 6
      else if (dict[this._colorKey(d)] && dict[this._colorKey(d)].thickness === 'medium') return 3
      else return 1
    } else return 1
  }

  static _drawItems = function (data, rootSel, itemsName, className) {
    this[itemsName] = rootSel.selectAll(`.${className}`).data(data, d => d.id)
    this[itemsName + 'Enter'] = this[itemsName].enter().append('g').attr('class', className)
    this[itemsName + 'Exit'] = this[itemsName].exit()

    let duration = 0
    if (this.config.ItemsHelper.transition) {
      duration =
        this.config.ItemsHelper.transition === true
          ? DEFAULT_DURATION
          : this.config.ItemsHelper.transition
    }
    this._transitionDuration = duration

    let l =
      Array.isArray(this.data) && Array.isArray(this.data[0].value)
        ? this.data[0].value.length
        : data.length
    if (this.data.female) l = this.data.female[0].value.length
    let delayStep = Math.min(duration / l, DEFAULT_DELAY_STEP)

    if (this._zooming) {
      duration = 0
      delayStep = 0
    }

    this[itemsName + 'Trans'] = this[itemsName].transition().duration(duration)
    this[itemsName + 'EnterTrans'] = this[itemsName + 'Enter']
      .transition()
      .duration(duration)
      .delay((d, i) => i * delayStep)
    this[itemsName + 'ExitTrans'] = this[itemsName + 'Exit']
      .transition()
      .duration(duration)
      .remove()

    if (this.__itemsNames.indexOf(itemsName) < 0) this.__itemsNames.push(itemsName)
  }

  static beforeDraw() {
    if (
      typeof this.config.ItemsHelper.colorScale == 'string' &&
      this.config.ItemsHelper.colorScale.indexOf('sequential') >= 0
    ) {
      this.cachedColorScale.domain(d3_extent(this.data.map(d => this._colorKey(d)))).nice()
    }
    let bindingData = this.ghostData || this.data

    if (!Array.isArray(this.data)) {
      let types = ['male', 'female']
      types.forEach(type => {
        let className = `parent-${type}-${this.config.ItemsHelper.className}`
        this._drawItems(
          bindingData[type] || [],
          this.content || this.root,
          type + 'ParentItems',
          className
        )

        className = type + '-' + this.config.ItemsHelper.className
        this._drawItems(
          d => d.value,
          this[type + 'ParentItems'].merge(this[type + 'ParentItemsEnter']),
          type + 'Items',
          className
        )
      })
    } else if (this.data[0] && this.data[0].dimensions !== undefined) {
      // bindingData = [dimensions:[]] (Parallel coords)
      let className = `parent-${this.config.ItemsHelper.className}`
      this._drawItems(bindingData, this.content || this.root, 'parentItems', className)

      className = this.config.ItemsHelper.className
      this._drawItems(
        d =>
          Object.keys(d.dimensions).map(dim => ({
            id: dim,
            value: d.dimensions[dim],
            parentId: d.id,
          })),
        this.parentItems.merge(this.parentItemsEnter),
        'items',
        className
      )
    } else if (this.data[0] && Array.isArray(this.data[0].value)) {
      // bindingData = [[]] (Lines and Stackets)
      let className = `parent-${this.config.ItemsHelper.className}`
      this._drawItems(bindingData, this.content || this.root, 'parentItems', className)

      className = this.config.ItemsHelper.className
      this._drawItems(
        d => d.value,
        this.parentItems.merge(this.parentItemsEnter),
        'items',
        className
      )
    } else {
      // bindingData = [] (Bars)
      this._drawItems(
        bindingData,
        this.content || this.root,
        'items',
        this.config.ItemsHelper.className
      )
    }
    if (this.helperListeners['afterItemsHelper']) this.helperListeners['afterItemsHelper']()
  }
  static draw() {}
  static afterDraw() {
    if (this.constructor.name === 'PieChartChart')
      this._prevData = [...(this.ghostData || this.data)]
  }
}
